import { type DashRouteType, URL_PARTNER_SCOPED } from '@retailer-platform/dashboard/route-patterns'

const URL_ITEM_PRICE_MANAGEMENT = `${URL_PARTNER_SCOPED}/item-price-management`
const URL_ITEM_PRICE_MANAGEMENT_ACTIVE_RULES = `${URL_ITEM_PRICE_MANAGEMENT}/active-rules`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUESTS = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_CREATE = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests/new`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_DETAIL = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests/:changeRequestId`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_EDIT = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests/:changeRequestId/edit`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_REVIEW = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests/:changeRequestId/review`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_RULE_CHANGES = `${URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUESTS}/:changeRequestId/rule-changes`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_SAMPLE_PRICE_CHANGES = `${URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUESTS}/:changeRequestId/sample-price-changes`
const URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_PRICE_QA = `${URL_ITEM_PRICE_MANAGEMENT}/change-requests/:changeRequestId/price-qa`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'item-price-management'>
  | DashRouteType<'item-price-management-active-rules'>
  | DashRouteType<'item-price-management-change-requests'>
  | DashRouteType<'item-price-management-change-request-create'>
  | DashRouteType<'item-price-management-change-request-detail'>
  | DashRouteType<'item-price-management-change-request-edit'>
  | DashRouteType<'item-price-management-change-request-review'>
  | DashRouteType<'item-price-management-change-request-rule-changes'>
  | DashRouteType<'item-price-management-change-request-sample-price-changes'>
  | DashRouteType<'item-price-management-change-request-price-qa'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'item-price-management': URL_ITEM_PRICE_MANAGEMENT,
  'item-price-management-active-rules': URL_ITEM_PRICE_MANAGEMENT_ACTIVE_RULES,
  'item-price-management-change-requests': URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUESTS,
  'item-price-management-change-request-create': URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_CREATE,
  'item-price-management-change-request-detail': URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_DETAIL,
  'item-price-management-change-request-edit': URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_EDIT,
  'item-price-management-change-request-review': URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_REVIEW,
  'item-price-management-change-request-rule-changes':
    URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_RULE_CHANGES,
  'item-price-management-change-request-sample-price-changes':
    URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_SAMPLE_PRICE_CHANGES,
  'item-price-management-change-request-price-qa':
    URL_ITEM_PRICE_MANAGEMENT_CHANGE_REQUEST_PRICE_QA,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
